import { useLocalization } from "@shared-ui/localization-context";

export const formatTimeSincePosted = (createTime: Date) => {
  const today = new Date();
  const datePosted = new Date(createTime);
  const elapsedTimeInSeconds = (today.getTime() - datePosted.getTime()) / 1000;

  const hoursPassed = Math.floor(elapsedTimeInSeconds / 3600);
  const daysPassed = Math.floor(elapsedTimeInSeconds / 86400);
  const weeksPassed = Math.floor(elapsedTimeInSeconds / 604800);
  const monthsPassed = Math.floor(elapsedTimeInSeconds / 2592000);

  const { formatText } = useLocalization();

  if (hoursPassed === 0) {
    return formatText("destinationReviews.lessThanOneHourAgo");
  }
  if (hoursPassed === 1) {
    return formatText("destinationReviews.oneHourAgo");
  }
  if (hoursPassed < 24) {
    return formatText("destinationReviews.hoursAgo", hoursPassed);
  }
  if (daysPassed === 1) {
    return formatText("destinationReviews.oneDayAgo");
  }
  if (daysPassed < 7) {
    return formatText("destinationReviews.daysAgo", daysPassed);
  }
  if (weeksPassed === 1) {
    return formatText("destinationReviews.oneWeekAgo");
  }
  if (monthsPassed < 1) {
    return formatText("destinationReviews.weeksAgo", weeksPassed);
  }
  if (monthsPassed === 1) {
    return formatText("destinationReviews.oneMonthAgo");
  }
  if (monthsPassed < 12) {
    return formatText("destinationReviews.monthsAgo", monthsPassed);
  }
  if (monthsPassed === 12) {
    return formatText("destinationReviews.oneYearAgo");
  }

  return formatText("destinationReviews.overOneYearAgo");
};
